import GeneralCRUDModel, {
  ACTION_TYPES as CRUD_ACTION_TYPES,
} from "../general-crud";
import { thunk } from "easy-peasy";
import API from "API";

export const ACTION_TYPES = {
  ...CRUD_ACTION_TYPES,
  UPDATING_STATU: 13,
  UPDATED_STATU: 14,
};

export const ContractStoreModel = {
  ...GeneralCRUDModel("/transactional/contracts"),

  updateStatu: thunk(async (actions, payload) => {
    actions.setProcess(ACTION_TYPES.UPDATING_STATU);
    try {
      const result = await API.put(
        `/transactional/contracts/${payload.id}/updateStatu`,
        payload
      );
      actions.setProcess(ACTION_TYPES.UPDATED_STATU);
      actions.setResponse(result);
      return result;
    } catch (error) {
      console.error("Error while updating data -> ", error);
      actions.setError(error);
    }
    actions.setProcess(ACTION_TYPES.FINISHED);
  }),
};
